import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Routes } from './appRoutes';
import ProtectRoute from './protectRoute';
import NonAuthRoute from './nonAuthRoute';
import {
  Login,
  Forget_Password,
  DealerLogin,
  DealerForget_Passwords,
} from '../pages/non-auth/index';
import {
  Dashboard,
  Role_Management,
  EditRole,
  CreateRole,
  AuditLog,
  UserManagement,
  CreateUser,
  AuditLogUpdate,
  Controller,
  CreateController,
  EditController,
  Equipments,
  CreateEquipments,
  EditEquipments,
  Category,
  ManufactureUnit,
  ManufactureUnitEdit,
  Inventory,
  CustomerManagement,
  CustomerManagementEdit,
  EquipmentDetails,
  DealerManagement,
  CreateDealer,
} from '../pages/auth';
import Alert from '../pages/auth/alert';

const Routers = createBrowserRouter([
  {
    path: Routes.emptyPath,
    element: <Navigate to={Routes.dashboard.path} {...Routes.dashboard} />,
  },

  {
    path: Routes.login.path,
    element: <NonAuthRoute component={Login} {...Routes.login} />,
  },
  {
    path: Routes.dealerLogin.path,
    element: <NonAuthRoute component={DealerLogin} {...Routes.dealerLogin} />,
  },
  {
    path: Routes.forgotPassword.path,
    element: (
      <NonAuthRoute component={Forget_Password} {...Routes.forgotPassword} />
    ),
  },
  {
    path: Routes.dealerForgotPassword.path,
    element: (
      <NonAuthRoute
        component={DealerForget_Passwords}
        {...Routes.dealerForgotPassword}
      />
    ),
  },
  {
    path: Routes.dashboard.path,
    element: <ProtectRoute component={Dashboard} {...Routes.dashboard} />,
  },

  {
    path: Routes.roleManagement.path,
    element: (
      <ProtectRoute component={Role_Management} {...Routes.roleManagement} />
    ),
  },
  {
    path: Routes.createRole.path,
    element: <ProtectRoute component={CreateRole} {...Routes.createRole} />,
  },
  {
    path: Routes.editRole.path,
    element: <ProtectRoute component={EditRole} {...Routes.editRole} />,
  },

  {
    path: Routes.userManagement.path,
    element: (
      <ProtectRoute component={UserManagement} {...Routes.userManagement} />
    ),
  },
  {
    path: Routes.createUser.path,
    element: <ProtectRoute component={CreateUser} {...Routes.createUser} />,
  },
  {
    path: Routes.editUser.path,
    element: <ProtectRoute component={CreateUser} {...Routes.editUser} />,
  },

  {
    path: Routes.auditLog.path,
    element: <ProtectRoute component={AuditLog} {...Routes.auditLog} />,
  },
  {
    path: Routes.auditLogUpdate.path,
    element: (
      <ProtectRoute component={AuditLogUpdate} {...Routes.auditLogUpdate} />
    ),
  },

  {
    path: Routes.editProfile.path,
    element: (
      <ProtectRoute component={AuditLogUpdate} {...Routes.editProfile} />
    ),
  },
  {
    path: Routes.hardwareManagement.path,
    element: (
      <ProtectRoute component={Controller} {...Routes.hardwareManagement} />
    ),
  },
  {
    path: Routes.createController.path,
    element: (
      <ProtectRoute component={CreateController} {...Routes.createController} />
    ),
  },
  {
    path: Routes.EditController.path,
    element: (
      <ProtectRoute component={EditController} {...Routes.EditController} />
    ),
  },
  {
    path: Routes.Equipments.path,
    element: <ProtectRoute component={Equipments} {...Routes.Equipments} />,
  },
  {
    path: Routes.CreateEquipments.path,
    element: (
      <ProtectRoute component={CreateEquipments} {...Routes.CreateEquipments} />
    ),
  },
  {
    path: Routes.EditEquipments.path,
    element: (
      <ProtectRoute component={EditEquipments} {...Routes.EditEquipments} />
    ),
  },
  {
    path: Routes.Category.path,
    element: <ProtectRoute component={Category} {...Routes.Category} />,
  },
  {
    path: Routes.ManufactureUnit.path,
    element: (
      <ProtectRoute component={ManufactureUnit} {...Routes.ManufactureUnit} />
    ),
  },
  {
    path: Routes.ManufactureUnitCreate.path,
    element: (
      <ProtectRoute
        component={ManufactureUnit}
        {...Routes.ManufactureUnitCreate}
      />
    ),
  },
  {
    path: Routes.ManufactureUnitEdit.path,
    element: (
      <ProtectRoute
        component={ManufactureUnitEdit}
        {...Routes.ManufactureUnitEdit}
      />
    ),
  },
  {
    path: Routes.Inventory.path,
    element: <ProtectRoute component={Inventory} {...Routes.Inventory} />,
  },
  {
    path: Routes.CustomerManagement.path,
    element: (
      <ProtectRoute
        component={CustomerManagement}
        {...Routes.CustomerManagement}
      />
    ),
  },
  {
    path: Routes.CustomerManagementEdit.path,
    element: (
      <ProtectRoute
        component={CustomerManagementEdit}
        {...Routes.CustomerManagementEdit}
      />
    ),
  },
  {
    path: Routes.EquipmentDetails.path,
    element: (
      <ProtectRoute component={EquipmentDetails} {...Routes.EquipmentDetails} />
    ),
  },
  {
    path: Routes.DealerManagement.path,
    element: (
      <ProtectRoute component={DealerManagement} {...Routes.DealerManagement} />
    ),
  },
  {
    path: Routes.CreateDealerManagement.path,
    element: (
      <ProtectRoute
        component={CreateDealer}
        {...Routes.CreateDealerManagement}
      />
    ),
  },
  {
    path: Routes.EditDealerManagement.path,
    element: (
      <ProtectRoute component={CreateDealer} {...Routes.EditDealerManagement} />
    ),
  },
  {
    path: Routes.EquipmentManagemnet.path,
    element: (
      <ProtectRoute component={Inventory} {...Routes.EquipmentManagemnet} />
    ),
  },
  {
    path: Routes.EquipmentManagemnetDetails.path,
    element: (
      <ProtectRoute
        component={EquipmentDetails}
        {...Routes.EquipmentManagemnetDetails}
      />
    ),
  },
  {
    path: Routes.InventoryEquipmentDetails.path,
    element: (
      <ProtectRoute
        component={EquipmentDetails}
        {...Routes.InventoryEquipmentDetails}
      />
    ),
  },
  {
    path: Routes.alert.path,
    element: <ProtectRoute component={Alert} {...Routes.alert} />,
  },
]);

export default Routers;
